import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export enum McmDroneType {
  PHOTO = 'PHOTO',
  VIDEO_LIMITED = 'VIDEO_LIMITED',
  VIDEO_FULL = 'VIDEO_FULL',
  VIDEO_PHOTO = 'VIDEO_PHOTO',
}

export default createPerformableConfig(
  'drone',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(McmDroneType),
      twilight: coerceBoolean().optional()
    }),
  },
  {
    name: 'Drone Services',
    short: '',
    package: 'Drone',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
